// extracted by mini-css-extract-plugin
module.exports = {"datesWrapper":"dates_datesWrapper__KubOT"};